import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";
import QuizPopup from "./QuizPopup";
import React, { useState } from "react";


const SectionFour = () => {
  const [showQuiz, setShowQuiz] = useState(false);

  const handleQuizComplete = (answers) => {
    console.log("User answers:", answers);
    // You can process the answers here
  };
  
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const hoverEffect = {
    whileHover: { scale: 1.05 },
    transition: { duration: 0.3 },
  };

  return (
    <div>
      <StickyNavbar />
      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div variants={fadeIn}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl my-5 md:my-10 font-bold text-center capitalize">
            How Should Research be Conducted?
          </h2>
          <p>
            Conducting research involves following certain steps.(49-51) We will
            go through some of these stages in more detail later, but below you
            will find some of the most important aspects of carrying out
            research. To guide us through these, we can use an example about
            understanding barriers to child and maternal health care in the
            community.
          </p>
        </motion.div>

        {/* Image */}
        <motion.div
          className=" rounded-lg p-4"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex justify-center">
            <img
              src="/images/conducted.png"
              alt="Local leaders supporting research"
              className="w-full max-w-md rounded-md"
            />
          </div>
          <p className="text-center text-sm mt-2">
            Field Mission in Nigeria. © 2018 European Union (photo by Samuel
            Ochai), used under CC BY-NC-ND 2.0. Source:
          </p>
        </motion.div>

        {/* Research Steps */}
        <motion.div className="space-y-6 mt-6" variants={fadeIn}>
          <p>
            <span className="text-[#005FFF]">❖</span> Define the purpose and goals: Start by clearly laying out what you
            are trying to achieve with your research. This means knowing the
            main question or problem the research will address. In this case,
            the question might be,{" "}
          </p>
          <p>
            “What barriers prevent women in the community from accessing child
            and maternal health care?”
          </p>
          <p>
            Beginning the research by doing this helps keep the research focused
            and helps you make sure that everything you do in your research is
            going to help you in understanding a specific issue.
          </p>
          <p>
            <span className="text-[#005FFF]">❖</span> Plan the research steps: Create a plan that organizes each stage
            of the research. An important part of this is to outline the roles
            for everyone involved in the research. Who is going to be doing
            what? Another step should be deciding who can participate. For our
            study, this could be expecting mothers. Another step might be
            identifying key questions such as, “What challenges do you face in
            accessing care?”, and choosing how data will be collected (e.g.,
            through interviews or surveys).
          </p>
          <p>
            <span className="text-[#005FFF]">❖</span> Collect your data: Collecting data might involve talking to
            mothers or expecting mothers about their experiences. Collecting
            data in this way is called interviewing, which will go into more
            detail later. During the interview you would actively listen, take
            notes about what they say, and focus on capturing their experiences.
          </p>
          <p>
            <span className="text-[#005FFF]">❖</span> Analyze and share what you find: When you have collected your
            data, it's time to look for patterns or insights that help answer
            your question. From your data you might discover common themes such
            as issues with transport, financial problems, or cultural beliefs
            which are affecting their access to child and maternal health care.
            You may also not discover what you expected to discover. However,
            the research is still important, and you should share what you find
            with others. Anything you find out may go on to help guide the
            development of programs to support better this kind of care.
          </p>
          <p>
            <span className="text-[#005FFF]">❖</span> Be ethical: Ethics are essential to protect participants and build
            trust. Doing research ethically means doing our best to make sure no
            harm comes to participants at every stage of the research. As this
            is such an important part of research, in the Next we will go into
            more detail about research ethics. (52)
          </p>
        </motion.div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-10">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter1/SectionThree">
              <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
          </motion.div>
          <div className="flex justify-center ">
          <button
            onClick={() => setShowQuiz(true)}
            className="bg-white text-blue-800 border lg:px-3 border-blue-800 px-1  py-2 rounded-lg "
          >
            Test Your Knowledge
          </button>
        </div>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/chapter2/video">
              <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
      {showQuiz && (
        <QuizPopup
          onClose={() => setShowQuiz(false)}
          onComplete={handleQuizComplete}
        />
      )}
    </div>
  );
};

export default SectionFour;
